import { Link } from "@tanstack/react-router";

import { Section, SectionHead, ghostButton } from "../../components/section";
import { ServiceGrid, ServiceGridSkeleton } from "../../components/service-card";
import { sitePath, useSiteConfig } from "../../hooks/use-site-config";
import type { PublicDirectory } from "../../types";
import { m } from "@/paraglide/messages.js";

/** Services the home page has room for; the rest are a click away. */
const VISIBLE = 6;

/**
 * The trainer's booking services, one card each. A trainer who has not set any up yet gets no
 * section at all rather than an empty one.
 */
export const ServicesBand = ({ directory, loading }: { directory: PublicDirectory | null; loading?: boolean }) => {
  const { slug } = useSiteConfig();
  const services = directory?.services ?? [];
  if (!loading && services.length === 0) return null;

  return (
    <Section id="sessions">
      <SectionHead
        title={m.landing_services_title()}
        aside={
          services.length > VISIBLE ? (
            <Link to={sitePath(slug, "services")} className={ghostButton}>
              {m.landing_services_all()}
            </Link>
          ) : undefined
        }
      />
      {directory && !loading ? (
        <ServiceGrid services={services.slice(0, VISIBLE)} directory={directory} />
      ) : (
        <ServiceGridSkeleton />
      )}
    </Section>
  );
};
